import { render, staticRenderFns } from "./WaveMatrixView.vue?vue&type=template&id=d621af34&"
import script from "./WaveMatrixView.vue?vue&type=script&lang=ts&"
export * from "./WaveMatrixView.vue?vue&type=script&lang=ts&"
import style0 from "./WaveMatrixView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
